import { memo } from "react";
import {
  AdvertiserAudiencesContextConsumer,
  AdvertiserAudiencesV3Wrapper,
} from "features/mediaDataRoom/contexts";
import { AudiencesContext } from "../models";

export const AudiencesV3Wrapper = memo<React.PropsWithChildren>(
  ({ children }) => (
    <AdvertiserAudiencesV3Wrapper>
      <AdvertiserAudiencesContextConsumer>
        {(contextValue) => (
          <AudiencesContext.Provider value={contextValue}>
            {children}
          </AudiencesContext.Provider>
        )}
      </AdvertiserAudiencesContextConsumer>
    </AdvertiserAudiencesV3Wrapper>
  )
);
AudiencesV3Wrapper.displayName = "AudiencesV3Wrapper";

export default AudiencesV3Wrapper;
